module.exports = function() {
    return {
      id: makeId(),
      count:0,
      rowsToggleState:{},
      windowWidth:window.innerWidth,
    }
  }

function makeId()
{
  var text = "";
  var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

  for( var i=0; i < 5; i++ )
    text += possible.charAt(Math.floor(Math.random() * possible.length));

  return text;
}



// WEBPACK FOOTER //
// ./~/vue-tables-2/lib/mixins/data.js